import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageMeta from '../components/PageMeta';

const NotFound = () => {
  return (
    <div>
      <PageMeta 
        title="404 - Page Not Found | RDS Studio"
        description="The page you're looking for doesn't exist. Return to RDS Studio homepage for web design, digital marketing, and SEO services in Centurion."
        canonical="https://rdsstudio.co.za/404"
      />
      
      <Header />
      
      <section className="section" style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="section-inner" style={{
          textAlign: 'center',
          maxWidth: '600px'
        }}>
          <div style={{
            fontSize: '8rem',
            fontWeight: '700',
            background: 'linear-gradient(135deg, #00d4ff, #7ba098)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            lineHeight: '1'
          }}>
            404
          </div>
          
          <h1 className="title title-h1" style={{ marginBottom: '1rem' }}>
            Page Not Found
          </h1>
          
          <p className="description" style={{
            fontSize: '1.125rem',
            marginBottom: '2rem',
            color: 'var(--text-secondary)'
          }}>
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </p>
          
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/" className="btn btn-primary">
              Go Home
            </Link>
            <Link to="/portfolio" className="btn btn-secondary">
              View Portfolio
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              Contact Us
            </Link>
          </div>
          
          <div style={{
            marginTop: '3rem',
            padding: '1.5rem',
            background: 'rgba(123, 160, 152, 0.05)',
            border: '1px solid rgba(123, 160, 152, 0.2)',
            borderRadius: '12px'
          }}>
            <h3 style={{
              fontSize: '1.125rem',
              marginBottom: '1rem',
              color: 'var(--text-primary)'
            }}>
              Popular Pages
            </h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
              gap: '0.75rem'
            }}>
              <Link to="/services" style={{
                padding: '0.75rem',
                background: 'rgba(22, 33, 62, 0.5)',
                border: '1px solid rgba(45, 45, 68, 0.3)',
                borderRadius: '8px',
                color: 'var(--text-primary)',
                textDecoration: 'none',
                transition: 'all 0.2s',
                fontSize: '0.9rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = 'var(--color-secondary)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = 'rgba(45, 45, 68, 0.3)';
                e.target.style.transform = 'translateY(0)';
              }}>
                Services
              </Link>
              <Link to="/about" style={{
                padding: '0.75rem',
                background: 'rgba(22, 33, 62, 0.5)',
                border: '1px solid rgba(45, 45, 68, 0.3)',
                borderRadius: '8px',
                color: 'var(--text-primary)',
                textDecoration: 'none',
                transition: 'all 0.2s',
                fontSize: '0.9rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = 'var(--color-secondary)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = 'rgba(45, 45, 68, 0.3)';
                e.target.style.transform = 'translateY(0)';
              }}>
                About
              </Link>
              <Link to="/blog" style={{
                padding: '0.75rem',
                background: 'rgba(22, 33, 62, 0.5)',
                border: '1px solid rgba(45, 45, 68, 0.3)',
                borderRadius: '8px',
                color: 'var(--text-primary)',
                textDecoration: 'none',
                transition: 'all 0.2s',
                fontSize: '0.9rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = 'var(--color-secondary)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = 'rgba(45, 45, 68, 0.3)';
                e.target.style.transform = 'translateY(0)';
              }}>
                Blog
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default NotFound;
